import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../general.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-get-qoute',
  templateUrl: './get-qoute.component.html',
  styleUrls: ['./get-qoute.component.css'],
})
export class GetQouteComponent implements OnInit {
  constructor(public s: GeneralService, private fb: FormBuilder, private r:Router, private tstr:ToastrService) {
    this.pkgs = [];
    this.minDate = new Date();
    this.countries = [];
  }
  pkgs: any[];
  countries: {[key:string]:string}[];
  minDate: Date | string;
  // minDate = new Date();
  qoute = 0.0;

  policyForm = this.fb.group({
    startDate: [Date, Validators.required],
    endDate: [Date, Validators.required],
    packageName: ['', Validators.required],
    country: [{ value: '', disabled: true }, Validators.required],
    DOB: ['', Validators.required],
    categoryName: [''],
    countryId: [''],
    userAge: [''],
  });
  ngOnInit(): void {
    setTimeout(() => {
      this.s.getPkgs().subscribe((r: any) => {
        this.s.smLoader = false;
        this.pkgs = r;
      });
    }, 3000);
  }

  noOfDays = 0;
  calcNoDays() {
    let timeDiff =
      new Date(this.policyForm.controls.endDate.value?.toString()!).getTime() -
      new Date(this.policyForm.controls.startDate.value?.toString()!).getTime();
    this.noOfDays = timeDiff / (1000 * 3600 * 24) + 1;
    console.log(this.noOfDays);
  }
  getCountriess() {
    this.s
      .getCountries(this.policyForm.controls.packageName.value!)
      .subscribe((r) => {
        this.s.smLoader = false;
        this.countries = r.countries;
        this.policyForm.controls.country.enable();
      });
  }
  pullCtgName(id: string) {
    console.log(this.pkgs);
    for (let index = 0; index < this.pkgs.length; index++) {
      if (this.pkgs[index]['_id'] == id) {
        return this.pkgs[index]['categoryName'];
      }
    }


    // return this.pkgs[index] = id;
  }

  pullCtryId(country: string) {
    console.log(this.countries);
    console.log(country)
    // console.log(countr)
    for (let index = 0; index < this.countries.length; index++) {
      if (this.countries[index]['countryName'] == country) {
        this.policyForm.controls.countryId.setValue(this.countries[index]['_id']);
      }
    }


    // return this.pkgs[index] = id;
  }

  agee(DOB: any) {
    return new Date().getFullYear() - new Date(DOB).getFullYear();
    //  this.noOfDays = (timeDiff / )
  }
  ready = false;
  getQoute() {
    this.policyForm.value.categoryName = this.pullCtgName(
      this.policyForm.controls.packageName.value!
    );
    this.policyForm.value.userAge = this.agee(
      this.policyForm.controls.DOB.value
    ).toString();
    this.s.getQoute(this.policyForm.value).subscribe((r) => {
      this.s.loader = false;
      this.ready = true;
      this.qoute = r;
    });
  }

  getCountries() {
    // this.student = false;
    let y = this.policyForm.controls.packageName.value!.toString();      
     if(y == '65328128ed296232df0da66e' || y == '6532830a2a5f686840013eb9'  ){
      this.s
        .getCountries(y)
        .subscribe((r: any) => {
        this.s.smLoader = false;
          this.countries = r.countries;
        });
    }else{
      this.s
      .getCountries()
      .subscribe((r: any) => {
        this.s.smLoader = false;
        this.countries = r;
      });
    }
    this.policyForm.controls.country.enable();  
  }
  move(){
    localStorage.setItem('qoute', JSON.stringify(this.policyForm.value))
    this.tstr.success('We have successfully saved your qoute details. kindly sign is to proceed')
    this.r.navigateByUrl('signin')
  }

}
